/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_NieuwbouwProject } from '../models/Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_NieuwbouwProject';
import type { Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_OfferingType } from '../models/Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_OfferingType';
import type { Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_TypeCountV3 } from '../models/Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_TypeCountV3';
import type { Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementsV3Response } from '../models/Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementsV3Response';
import type { Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementV3Response } from '../models/Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementV3Response';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WoonstadV3Service {

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementsV3Response OK
     * @throws ApiError
     */
    public static getOfferingByType30({
offeringType,
qson,
excludeitems,
excludefacets,
size = 10,
}: {
offeringType: Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_OfferingType,
qson?: string,
excludeitems?: boolean,
excludefacets?: boolean,
size?: number,
}): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementsV3Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/woonstad/offering/{offeringType}',
            path: {
                'offeringType': offeringType,
            },
            query: {
                'qson': qson,
                'excludeitems': excludeitems,
                'excludefacets': excludefacets,
                'size': size,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementV3Response OK
     * @throws ApiError
     */
    public static getOfferingDetailByUrl30({
url,
}: {
url?: string,
}): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Features_Woonstad_WoonstadAdvertisementV3Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/woonstad/offering/detail',
            query: {
                'url': url,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_NieuwbouwProject OK
     * @throws ApiError
     */
    public static getProjectById({
id,
}: {
id?: string,
}): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_NieuwbouwProject> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/woonstad/project/detail',
            query: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * @returns Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_TypeCountV3 OK
     * @throws ApiError
     */
    public static getTypeCountV3(): CancelablePromise<Woonstad_Foundation_Portfolio_Api_Features_Woonstad_Models_TypeCountV3> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v3/woonstad/typecount',
        });
    }

}
